// extracted by mini-css-extract-plugin
export default {"root":"YTKAgeKMrB3vpsqHFFG0","placeHolderShimmer":"GR0WlfLxdWFc98s7Zuvw"};